// src/components/SEO.jsx
import React from "react";
import { Helmet } from "react-helmet-async";

function SEO({ title, description, schema }) {
  /* Canonical: Normalize to remove trailing slash and query params */
  const getCanonicalUrl = () => {
    if (typeof window === "undefined") return "";
    try {
      const u = new URL(window.location.href);
      // Remove query params
      u.search = "";
      u.hash = "";
      // Remove trailing slash if not root
      let cleanUrl = u.toString();
      if (cleanUrl.endsWith("/") && u.pathname !== "/") {
        cleanUrl = cleanUrl.slice(0, -1);
      }
      return cleanUrl;
    } catch (e) {
      return window.location.href;
    }
  };

  const canonicalUrl = getCanonicalUrl();

  return (
    <Helmet>
      {/* Título y meta descripción */}
      <title>{title}</title>
      <meta name="description" content={description} />

      {/* Canonical dinámico */}
      <link rel="canonical" href={canonicalUrl} />

      {/* Robots y redes */}
      <meta name="robots" content="index, follow" />
      <meta property="og:image" content="/images/banner.webp" />
      <meta name="twitter:image" content="/images/banner.webp" />

      {/* Favicon */}
      <link rel="icon" href="/favicon.ico" type="image/x-icon" />
      <link rel="shortcut icon" href="/favicon.ico" type="image/x-icon" />

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="PIKDOV STUDIO" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />

      {/* Extra */}
      <meta
        name="author"
        content="Yeison PV - Desarrollador Web, Diseñador y Técnico"
      />
      <meta httpEquiv="content-language" content="es" />

      {/* JSON-LD Structured Data */}
      {schema && (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      )}
    </Helmet>
  );
}

export default SEO;
